import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  accept_assigned_assessment_kit_candidate_action,
  accept_assigned_assessment_kit_details_candidate_action,
  get_candidate_profile_data_action,
} from "../../../redux/_actions/candidate";
import { update_user_meta_data_action } from "../../../redux/_actions";
import { showWarningMessage } from "../../../_uiComponents/ShowMessageSnack";
function useAssignedInterviewKit() {
  const [interviewKit, setInterviewKit] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingError, setLoadingError] = useState();
  const [readMore, setReadMore] = useState(false);
  const [appliedJobId, setAppliedJobId] = useState(null);
  const [acceptLoading, setAcceptLoading] = useState(false);
  const [isDeclineAssessmentModal, setIsDeclineAssessmentModal] =
    useState(false);

  const [resumeUploadModal, setResumeUploadModal] = useState(false);
  const [isResumeLoading, setIsResumeLoading] = useState(false);
  const [pdfError, setPdfError] = useState(false);

  const [userInfo, setUserInfo] = useState({});

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { acceptAssignedAssessmentKitDetailsData } = useSelector(
    (state) => state.accept_assigned_assessment_kit_details_candidate_reducer
  );

  const { acceptAssignedAssessmentKitData } = useSelector(
    (state) => state.accept_assigned_assessment_kit_candidate_reducer
  );
  const { userProfileData } = useSelector(
    (state) => state.get_candidate_profile_data_reducer
  );
  useEffect(() => {
    let url = new URL(window.location.href);
    let interviewKitId = url.searchParams.get("interviewKit");
    let appliedJob = url.searchParams.get("appliedJob");
    if (interviewKitId && appliedJob) {
      setAppliedJobId(appliedJob);
      callApi(interviewKitId);
      getUserProfile();
    } else {
      setLoadingError("Unable to find the assessment kit you are looking for.");
    }
  }, []);

  useEffect(() => {
    if (acceptAssignedAssessmentKitDetailsData?.data) {
      let data = acceptAssignedAssessmentKitDetailsData?.data;
      let total_time = 0;
      let total_question = 0;
      data?.topics &&
        Array.isArray(data?.topics) &&
        data.topics.forEach((element) => {
          element?.questions &&
            element.questions.forEach(
              (time) => (total_time = time + total_time)
            );
          total_question =
            Array.isArray(element?.questions) &&
            element?.questions &&
            element.questions.length + total_question;
        });

      data["total_question"] = total_question;
      data["total_time"] = total_time;
      setInterviewKit(acceptAssignedAssessmentKitDetailsData?.data);
    }
  }, [acceptAssignedAssessmentKitDetailsData]);

  useEffect(() => {
    if (userProfileData?.data) {
      const resume =
        userProfileData?.data &&
        userProfileData?.data?.user_details &&
        userProfileData?.data.user_details?.user_meta_info &&
        userProfileData?.data.user_details.user_meta_info?.resume;

      if (resume) {
        setResumeUploadModal(false);
      }
      setUserInfo(userProfileData?.data);
    }
  }, [userProfileData]);

  const callApi = async (interviewKitId) => {
    setLoading(true);
    await dispatch(
      accept_assigned_assessment_kit_details_candidate_action(interviewKitId)
    );
    setLoading(false);
  };

  const onPracticeClick = () => {
    navigate(
      `/interview-instructions?practice=${interviewKit?.id}&appliedJob=${appliedJobId}`
    );
  };

  const onStartClick = () => {
    navigate(
      `/interview-instructions?appliedJob=${appliedJobId}&interviewKit=${interviewKit?.id}`
    );
  };

  const onSubmitClick = () => {
    navigate(
      `/interview-submit-review?appliedJob=${appliedJobId}&interviewKit=${interviewKit?.id}`
    );
  };

  const onAcceptAssessmentKitClick = async (is_accepted) => {
    const resume =
      userInfo?.user_details &&
      userInfo.user_details?.user_meta_info &&
      userInfo.user_details.user_meta_info?.resume;
    if (resume) {
      setAcceptLoading(true);
      const data = is_accepted
        ? { kit_accepted: is_accepted }
        : { kit_declined: !is_accepted };
      if (interviewKit?.id)
        await dispatch(
          accept_assigned_assessment_kit_candidate_action(
            interviewKit?.id,
            data
          )
        );

      setAcceptLoading(false);
      window.location.reload();
    } else {
      resumeModalClick(true);
    }
  };

  const onReadMoreClick = () => {
    setReadMore(!readMore);
  };

  const handleIsDeclineAssessmentModal = () => {
    setIsDeclineAssessmentModal(!isDeclineAssessmentModal);
  };

  const onNavigateBack = () => navigate(-1);

  const getUserProfile = async () => {
    await dispatch(get_candidate_profile_data_action());
  };

  const onResumeUpload = async (e, key) => {
    const file = e.target.files[0];
    const name = e.target.name;
    const data = new FormData();

    data.append(name, file);
    if (file) {
      if (file && file.type === "application/pdf") {
        setIsResumeLoading(true);
        await dispatch(update_user_meta_data_action(data));
        getUserProfile();
        setIsResumeLoading(false);
        setPdfError(false);
      } else {
        setPdfError(true);
        showWarningMessage("Please select a PDF file.");
      }
    } else {
      showWarningMessage("Resume Need to Uploaded");
    }
  };

  const resumeModalClick = (type) => {
    setResumeUploadModal(type);
  };
  return {
    loading,
    loadingError,
    interviewKit,
    readMore,
    acceptLoading,
    isDeclineAssessmentModal,
    resumeUploadModal,
    pdfError,
    isResumeLoading,
    resumeModalClick,

    onResumeUpload,
    onReadMoreClick,
    onPracticeClick,
    onStartClick,
    onSubmitClick,
    onAcceptAssessmentKitClick,
    handleIsDeclineAssessmentModal,
    onNavigateBack,
  };
}

export default useAssignedInterviewKit;
